<template>

    <div class="mt-5">
        
        <div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
                
        <a-row type="flex" :gutter="24" style="margin-top: -170px;margin-left: 20px; margin-right: 20px;">
            <a-col :span="24" :md="12" :sm="12" class="mb-24">
                    <height-watcher>
                        <div
                            class="budgets-page-body"
                            slot-scope="{ height, offset }"
                            :offset="offset"
                            :style="{
                                'max-height': height - (208) + 'px',
                                height: height - (208) + 'px',
                            }"
                        >
                            <a-card  :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: '12px',}">
                                <template #title>
                                    <div style="display: flex; align-items: center; justify-content: start; ">
                                        <official-dropdown 
                                            v-model='selectedOfficial' 
                                            style="width: 350px !important;"
                                            :validate-status="validations.statusOfficial"
                                            :help="validations.helpOfficial"
                                            @change="onOfficialSelected"
                                        />
                                        <a-form-item
                                            :label="$t('form-label.select-date')" 
                                            :style="{ display: 'inline-block', width: '350px', 'margin-left': '40px' }" 
                                            :validate-status="validations.statusDate"
                                            :help="validations.helpDate">
                                            
                                            <a-date-picker 
                                                style="width: 100%;"
                                                size="small" 
                                                v-model="selectedDate" 
                                                format="DD MMM, yyyy"
                                                :allowClear="false"
                                            />
                                        </a-form-item>  
                                        <a-button type="primary" @click="show" size="small" style="margin-top: 20px; margin-left: 40px;">
                                            {{$t('show-btn-caption')}}
                                        </a-button>                  
                                    </div>
                                    
                                    <div style="display: flex; align-items: center; justify-content: center; flex-direction: column;">    
                                        <h6 style="margin-top: 10px;">{{$t('appointment-time-line.sub-title')}} {{ selectedDate.format('DD MMM, yyyy (dddd)')}}</h6>
                                    </div>
                                    

                                    
                                </template>
                                <a-spin :spinning="isLoading" size="large">
                                    <div class="spin-content">
                                        <a-timeline class="appointment-timeline" style="min-height: 570px; max-height: 570px; overflow-y: scroll !important;">
                                            <appointment-timeline-item 
                                                v-for="(item, i) in selectedSchedules" 
                                                :key="i" 
                                                :item="item" 
                                                @approved="(e) => $emit('approved', e)"
                                                @cancel="performCancel"
                                            />
                                            <!-- <template #pendingDot> </template> -->
                                        </a-timeline>
                                    </div>
                                </a-spin>
                                <!-- <div v-show="!isOfficialSelected" style="min-height: 650px; max-height: 650px; overflow-y: scroll !important; display: flex; align-items: center; justify-content: center;">
                                    <a-empty
                                        image="/images/empty.png"
                                        :image-style="{ height: '60px' }">
                                        <span slot="description"> 
                                            <b class="text-primary">No Official Selected</b>
                                        </span>
                                    </a-empty>
                                </div> -->
                        
                            </a-card> 
                        </div>
                    </height-watcher>
            </a-col>
            
            <a-col :span="24" :lg="12" :md="12" :sm="12" class="mb-24">
                <!-- Existing appointments -->
                <height-watcher>
                    <div
                        class="budgets-page-body"
                        slot-scope="{ height, offset }"
                        :offset="offset"
                        :style="{
                            'max-height': height - (208) + 'px',
                            height: height - (208) + 'px',
                        }"
                    >
                        <schedule-calendar />
                    </div>
                </height-watcher>
            </a-col>
        </a-row>
                    
    </div>

</template>

<script>

import moment from 'moment';
import { mapActions, mapState } from 'pinia';
import { useAppointmentsStore } from '../../stores/appointments-store';
import { useMonthlySchedulesStore } from '../../stores/monthly-schedules-store';
import { toastMixin } from '../../mixins/ToastMixin';
import AppointmentTimelineItem from './timelines/AppointmentTimelineItem.vue';
import OfficialDropdown from '../../components/dropdowns/OfficialDropdown.vue';
import ScheduleCalendar from '../../views/appointments/ScheduleCalendar.vue';
import HeightWatcher from "../../components/height-watcher/HeightWatcher.vue";

export default ({
    components: {
        AppointmentTimelineItem,
        OfficialDropdown,
        ScheduleCalendar,
        HeightWatcher
    },
    mixins: [ toastMixin ],
    data() {
        return {
            isLoading: false,
            timelines: [],
            selectedDate: moment(),
            moment: moment,
            selectedOfficial: '',
            validations: {
                statusDate: '',
                helpDate: '',
                statusOfficial: '',
                helpOfficial: '',
            }
            
        }
    },
    computed: {
        ...mapState(useAppointmentsStore, [ 'schedules' ]),
        selectedSchedules() {
            try {
                return this.schedules[this.selectedOfficial].filter(i => i.date == this.selectedDate.format('YYYY-MM-DD'))[0].list || []
            } catch(error) {
                return [];
            }  
        }
    },
    methods: {
        ...mapActions(useAppointmentsStore, [ 'fetchAndCacheApointments', 'cancelAppointment' ]),
        ...mapActions(useMonthlySchedulesStore, [ 'selectOfficial' ]),
        fetchSchedules() {
            this.isLoading = true;
            console.log(this.selectedOfficial);
            this.fetchAndCacheApointments(this.selectedOfficial, this.selectedDate.format('YYYY-MM-DD')).then(() => {
                this.isLoading = false;
            });
        },
        performCancel(apt) {
            this.isLoading = true;
            this.cancelAppointment(apt).then(() => {
                this.isLoading = false;
                this.successToast(this.$t('toast-success-messages.cancel-appointment'));
            }).catch(() => {
                this.isLoading = false;
                this.errorToast(this.$t('toast-error-messages.cancel-appointment'));
            });
        },
        clearValidations() {
            Object.keys(this.validations).forEach(key => {
                this.validations[key] = '';
            });
        },
        show() {
            this.clearValidations();
            if (!this.selectedOfficial || this.selectedOfficial.length == 0) {
                this.validations.statusOfficial = 'error';
                this.validations.helpOfficial = this.$t('error-message.select-official');
                return;
            } 
            if (!this.selectedDate) {
                this.statusDate = 'error';
                this.helpDate = 'Please select a Date';
                return;
            }
            this.fetchSchedules();
        },
        onOfficialSelected(e) {
            
        }
    },
    watch: {
        selectedOfficial() {
            this.selectOfficial(this.selectedOfficial);
        }
    }
})

</script>